export const getTotalAnnualSales = (value) => {
  return {
    type: "GET_TOTAL_ANNUAL_SALES",
    payload: value,
  };
};
